import classNames from 'classnames';
import React, { FC, useRef } from 'react';

import { AccordionProps } from '../models';

interface AccordionContentProps
  extends Omit<AccordionProps, 'items' | 'headlineTag'> {
  index: number;
  isOpen: boolean;
  itemsLength: number;
}

export const AccordionContent: FC<AccordionContentProps> = ({
  semanticVariant,
  index,
  children,
  itemsLength,
  isOpen,
}) => {
  const contentItemHeight = useRef<number[]>([]);
  const ContentTag = semanticVariant === 'dl' ? 'dd' : 'div';

  return (
    <ContentTag
      className={classNames('cds-accordion__item-content-wrapper', {
        'cds-accordion__item-content-wrapper--last': index === itemsLength - 1,
        'cds-accordion__item-content-wrapper--open': isOpen,
      })}
      style={{
        height: isOpen ? contentItemHeight.current[index] : 0,
      }}
      aria-hidden={!isOpen}
    >
      <div
        ref={(child) => {
          if (contentItemHeight.current) {
            contentItemHeight.current[index] = child?.offsetHeight as number;
          }
        }}
        className={classNames('cds-accordion__item-content', {
          'cds-accordion__item-content--open': isOpen,
        })}
      >
        {children}
      </div>
    </ContentTag>
  );
};
